export const SOLIDGATE_ERROR_CODES = {
  INSUFFICIENT_FUNDS: '3.02'
}